'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _addible = require('../base/addible');

var _addible2 = _interopRequireDefault(_addible);

var _util = require('../util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Addible = function (_BaseAddible) {
  (0, _inherits3.default)(Addible, _BaseAddible);

  function Addible(data) {
    (0, _classCallCheck3.default)(this, Addible);
    return (0, _possibleConstructorReturn3.default)(this, (Addible.__proto__ || (0, _getPrototypeOf2.default)(Addible)).call(this, data));
  }

  (0, _createClass3.default)(Addible, [{
    key: 'cancel',
    value: function cancel() {
      return (0, _util.axios)({
        url: '/app/exchange/cart/packs?packId=' + this.data.id,
        method: 'DELETE'
      });
    }
  }, {
    key: 'add',
    value: function add(spvId, count) {
      return (0, _util.axios)({
        url: '/app/exchange/cart/packs',
        method: 'POST',
        json: [{
          spvId: spvId,
          count: count,
          source: 'ADDIBLE'
        }]
      });
    }
  }]);
  return Addible;
}(_addible2.default);

exports.default = Addible;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/model/points/addible.js
// module id = 1167
// module chunks = 0